import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_layout/device/remarkable_/connect'
)({
  component: () => (
    <Navigate to="/device/remarkable" replace search={{ showOtp: true }} />
  ),
});
